<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 棋盘系统 
                </el-breadcrumb-item>
				<el-breadcrumb-item>棋盘动态</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.sectId" placeholder="请选择棋派" filterable style="width:200px">
					<el-option key="" label="请选择棋派" value=""></el-option>
					<el-option v-for="item in chessSectKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;&nbsp;
				<el-date-picker
					type="datetime"
					placeholder="发布开始时间"
					v-model="query.publishTimeStart"
					value-format="yyyy-MM-dd HH:mm:SS"
				></el-date-picker> &nbsp;
				<el-date-picker
					type="datetime"
					placeholder="发布结束时间"
					v-model="query.publishTimeEnd"
					value-format="yyyy-MM-dd HH:mm:SS"
				></el-date-picker>&nbsp;
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAnalysis()"
					v-if="controll['analysis']"
                >棋招解析</el-button>
            </div>
			<el-empty description="无相关动态" v-if="tableData.length == 0"></el-empty>
			<el-timeline>
				<el-timeline-item v-for ="(item,index) in tableData" :timestamp="item.publishTime" placement="top">
					<el-card shadow="hover">
						<h3 style="padding-bottom:10px;">{{item.sectName}} 发布了 {{item.key}} 动态</h3>
						<img style = "position: absolute; top: 8px; right: 0;" src="../../../assets/img/new.png" width="80px" height="40px" v-if="Math.abs(new Date(item.publishTime) - new Date()) / (60 * 1000) < 1440">
						<h5 style="padding-bottom:15px; font-size:14px">{{item.player}} 发布于 {{item.publishTime}}</h5>
						<div style="padding-top:10px;" v-html= "item.content"></div>
						<div style="padding-right:10px; padding-top:10px;" v-if="item.image">
							<el-tooltip content="点击图片放大" placement="right" v-for = "payReceiptItem in item.image.split(',')">
								<div style="float:left; margin-right:15px;margin-bottom:30px">
									<el-image
										class="table-td-thumb"
										:src="imgPrefix+payReceiptItem"
										:preview-src-list="[imgPrefix+payReceiptItem]"
									></el-image>
								</div>
							</el-tooltip>
						</div>
					</el-card>
				</el-timeline-item>
			</el-timeline>
        </div>
		<v-Analysis ref="child"></v-Analysis>
    </div>
	
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchChessQzoneData, saveChessQzone, getChessQzone, getChessSectKV, fetchChessQzoneList, synchronousLatestReadQzoneId } from '../../../api/index';
import vAnalysis from '../../common/Analysis.vue';
import bus from '../../common/bus';
export default {
    name: 'chess-qzone',
    data() {
        return {
            query: {
                code: '',
                name: '',
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
			title:"",
			rules: {
                key: [{ required: true, message: '关键字不能为空', trigger: 'blur' }]
            },
			chessSectKV:[],
			analysisVisible:false,
			activeNames:[],
			imgPrefix:"/image",
			unReadQzones:[],
			controll:{}
        };
    },
    created() {
		this.controll = getControll('chess-qzone');
		this.getChessSect();
        this.getData();
		this.synchronousLatestQzoneId();
    },
	components: {
        vAnalysis
    },
    methods: {
		getChessSect() {
			getChessSectKV().then(res => {
				if (res.code == 0 ) {
					this.chessSectKV = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			})
		},
		synchronousLatestQzoneId() {
			synchronousLatestReadQzoneId().then(res => {
				if (res.code == 0) {
					bus.$emit('unReadQzoneSize', 0);
				}else{
					this.$message.error("动态数据同步失败！" + res.message);
				}
			});
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchChessQzoneData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
		//解析操作
		handleAnalysis() {
			let current_query = {};
			current_query["code"] = this.query["code"];
			current_query["name"] = this.query["name"];
			current_query["pageNum"] = this.query["pageNum"];
			current_query["pageSize"] = this.query["pageSize"];
			current_query["status"] = 0;
			fetchChessQzoneList(current_query).then(res => {
				if (res.code == 0) {
					let source = "";
					let ids = [];
					for(var i = 0; i < res.data.length; i++) {
						source = source + res.data[i]["player"] + "  " + res.data[i]["publishTime"] + "\r\n"
						source = source + res.data[i]["content"] + "\r\n\r\n"
						ids.push(res.data[i]["id"]);
					}
					this.$refs.child.setAnalysisData(source, "qzone", undefined, ids);
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			});
		},
        // 分页导航
        handleScroll() {
			const container = document.getElementsByClassName('content')[0];
			if (container.clientHeight + container.scrollTop + 1 >= container.scrollHeight && this.query["pageNum"] < this.pageTotal) {
				this.$set(this.query, 'pageNum', this.query["pageNum"] + 1);
				this.$set(this.query, 'pageIndex', this.query["pageNum"] + 1);
				fetchChessQzoneData(this.query).then(res => { 
					if (res.code == 0 ) {
						for (var i = 0; i < res.data.records.length; i++){
							this.tableData.push(res.data.records[i]);
						}
						this.pageTotal = res.data.total;
					} else {
						this.$message.error("获取数据失败！" + res.message);
					}
				});
			}
            
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 120px;
    height: 150px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
